import RegisterPhoneError from './RegisterPhoneError';
class CountryCodeIsNotSupported extends RegisterPhoneError {
    constructor(lada, options) {
        super(`Phone country lada: ${lada} is not suported`, options);
    }
}
export default CountryCodeIsNotSupported;
